import { EventEmitter } from "events";
import { CoObjectItem } from "../../components/interfaces/CoObject";

class AsyncObjectUpdateManager extends EventEmitter {
  constructor() {
    super();
    this.coObject = undefined;
  }

  coObject: CoObjectItem;

  addUpdatedObject(coObject: CoObjectItem) {
    this.coObject = coObject;
    this.emitUpdate();
  }

  emitUpdate() {
    this.emit("ASYNC-OBJECT-UPDATE", this.coObject);
  }

  addAsyncObjectUpdateListener(callback) {
    this.addListener("ASYNC-OBJECT-UPDATE", callback);
  }

  removeAsyncObjectUpdateListener(callback) {
    this.removeListener("ASYNC-OBJECT-UPDATE", callback);
  }
}

export default new AsyncObjectUpdateManager();
